import { createSlice } from '@reduxjs/toolkit';
import { decryptText } from '../../utils/utils';

type AuthType = {
	userDetails?: any;
	token?: string | null;
	session_expires?: any;
};

let auth: AuthType = {};
try {
	const encryptedToken = localStorage.getItem('auth_sess_token');
	if (encryptedToken) {
		const decrypted = decryptText(encryptedToken);
		auth = JSON.parse(decrypted || '{}');
	}
} catch (error) {
	console.error('Error parsing auth_sess_token:', error);
	auth = {};
}

const initialState = {
	userDetails: auth.userDetails ?? null,
	token: auth.token ?? null,
	session_expires: auth.session_expires ?? null,
};

const authUserSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setAuthUser: (state, action) => {
			return { ...state, ...action.payload };
		},
		deleteAuthUser: () => {
			return { userDetails: {}, token: null, session_expires: null };
		}
	},
});

export const { setAuthUser, deleteAuthUser } = authUserSlice.actions;

export default authUserSlice.reducer;
